import * as React from "react";
import { Datagrid, TextField } from "react-admin";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { EnumField } from "../../../Components/EnumField";
import { useVerifyPermission } from "@airborne/react-admin";
import { useAppDataProvider } from "../../../dataprovider";
import { GetStepType } from "../../../Enums/StepType";
import FilterToolbar from "../../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType, FilterTypes } from "../../../Enums/FilterTypes";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { MailManagementExcelHeader, MailManagementExcelName } from "./Constant";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const MailManagementList = props => {
  useVerifyPermission("mailmanagements", "read");
  const [customers, setCustomers] = React.useState<any>();
  const dataProvider = useAppDataProvider();

  React.useEffect(() => {
    GetCustomers();
  }, []);

  const GetCustomers = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerCode", order: "ASC" },
        filter: {},
      })
      .then(response => {
        setCustomers(response.data);
      });
  };

  const ExportToExcel = records => {
    ExcelExport(
      MailManagementExcelHeader,
      records.map(v => [
        v.customer?.ownerCode ?? "",
        v.to,
        v.cc,
        v.subject,
        GetStepType.filter(x => x.Value === v.stepTypeEnum)[0]?.Text ?? "",
      ]),
      MailManagementExcelName
    );
  };

  return (
    <PoolList
      {...props}
      title={"Mail Management"}
      sort={DefaultCreatedDateSort}
      perPage={DefaultPerPageSize}
      bulkActionButtons={false}
      exporter={ExportToExcel}
      filters={
        <FilterToolbar
          dataSource={[
            {
              source: "customer.ownerCode",
              inputType: FilterInputType.Select,
              label: "Customer",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.Equals,
              choices: customers,
              optionValue: "ownerCode",
              optionText: "ownerCode",
            },
            {
              source: "to",
              inputType: FilterInputType.Text,
              label: "TO",
            },
            {
              source: "cc",
              inputType: FilterInputType.Text,
              label: "CC",
            },
            {
              source: "subject",
              inputType: FilterInputType.Text,
              label: "Subject",
            },
            {
              source: "stepTypeEnum",
              inputType: FilterInputType.Select,
              label: "Schema",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.Equals,
              choices: GetStepType,
              optionValue: "Value",
              optionText: "Text",
            },
          ]}
        />
      }
    >
      <Datagrid {...props} optimized rowClick="edit">
        <TextField source="customer.ownerCode" label="Customer" />
        <TextField source="to" label="To" />
        <TextField source="cc" label="Cc" />
        <TextField source="subject" label="Subject" />
        <EnumField label={"Schema"} enumName={"StepType"} source={"stepTypeEnum"} />
      </Datagrid>
    </PoolList>
  );
};

export default MailManagementList;
